module.exports = __webpack_public_path__ + "zip.jpg?09f1e8dc73800638f48f99968c078389";